export default "/_next/static/chunks/fonts/Roboto-Regular-latin-cfba0239aa54fa9645fe4204ba703146.woff2";